import styled from 'styled-components';

export const BonusTitleStyled = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    background-image: url('/assets/bonus/bonus-bg.svg'), linear-gradient(270deg, #EBC962 0%, #B67F3C 100%);
    background-position: center;
    ${({ onClick }) => onClick && 'cursor: pointer;'}
`;

export const BonusTitleContentStyled = styled.div`
    padding: 10px 8px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const BonusTitleAmountStyled = styled.div`
    padding-right: 3px;
    background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : 'var(--color-surface-secondary)'};
    color: #EBC962;
    font-weight: 600;
    border-radius: 0 4px 4px 0;
`;

export const BonusTitleDescriptionStyled = styled.div`
    padding: 0 8px;
    font-weight: 500;
    font-size: 12px;
    color: var(--color-surface);
`;

export const BonusTitleTimerStyled = styled.div`
    padding: 0 8px 0 4px;
    display: flex;
    align-items: center;
    height: 24px;
    font-size: 12px;
    font-weight: 500;
    background-color: var(--color-surface-secondary);
    color: #EBC962;
    border-radius: 2px;
    svg {
        margin-right: 4px;
        font-size: 16px;
        fill: #EBC962;
    }
`;
